import makeStyles from "@material-ui/core/styles/makeStyles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  arrow: {
    position: "absolute",
    top: -12,
    left: "calc(50% - 18px)",
    width: 0,
    height: 0,
    borderStyle: "solid",
    borderWidth: "0 18px 14px 18px",
    borderColor: "transparent transparent #ffffff transparent"
  },
  arrowBottom: {
    top: "auto",
    bottom: -12,
    borderWidth: "18px 14px 0 18px",
    borderColor: "#ffffff transparent transparent transparent"
  },
  showArrow: {
    display: "block"
  },
  dateMenu: {
    "& .MuiPaper-root": {
      overflow: "visible",
      height: 167
    },
    "& .MuiPopover-paper": {
      marginTop: 16
    },
    "& .MuiMenu-list": {
      minWidth: 296,
      padding: 0
    },
    "& .MuiTypography-root": {
      fontSize: 14
    },
    "& .MuiListItem-root": {
      minHeight: 55
    },
    "& .MuiListItemIcon-root": {
      minWidth: 32
    }
  },
  menuIcon: {
    color: theme.palette.text.primary
  },
  backIcon: {
    color: theme.palette.text.secondary
  },
  arrowRight: {
    "&.MuiListItemIcon-root": {
      minWidth: 0
    }
  },
  menuTop: {
    "& .MuiPopover-paper": {
      marginTop: -16
    }
  },
  facilityIconTransform: {
    width: 20,
    height: 12,
    marginBottom: 2,
    "& > span": {
      width: 16,
      height: 8
    }
  },
  backButton: {
    "&.MuiListItem-root": {
      minHeight: 32,
      height: 32
    },
    "& .MuiListItemText-primary": {
      fontSize: 14,
      color: theme.palette.text.secondary
    },
    "& .MuiListItemIcon-root": {
      minWidth: 16,
      marginRight: 0
    },
    "& .MuiSvgIcon-root": {
      fontSize: 13
    }
  },
  facilitiesWrapper: {
    overflow: "auto",
    height: "calc(100% - 32px)"
  },
  facility: {
    "&.MuiListItem-root": {
      minHeight: 44,
      height: 44
    },
    "& .MuiListItemIcon-root": {
      minWidth: 42
    }
  },
  disabled: {
    opacity: 0.2,
    pointerEvents: "none"
  },
  slidesContainer: {
    position: "relative",
    display: "flex",
    overflow: "hidden",
    width: 296,
    height: 167
  },
  menuSlide: {
    position: "absolute",
    width: 296,
    bottom: 0,
    top: 0
  },
  mainMenuShow: {
    transition: "left 300ms",
    left: 0
  },
  mainMenuHide: {
    transition: "left 300ms",
    left: "-100%"
  },
  facilityMenuHide: {
    transition: "left 300ms",
    left: "100%"
  },
  facilityMenuShow: {
    transition: "left 300ms",
    left: 0
  },
  link: {
    textDecoration: "none"
  }
}));
